import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import addMonths from 'date-fns/add_months';
import addDays from 'date-fns/add_days';
export default {
  namespaced: true,
  state: {
    datachart: [],
    optionsCohort: [],
    cohortSelected: 'all',
    insight_cohorts: [],
    selectmonth: [],
    question_category: [],
    insightcohortsByComp: [],
    datalist: [],
    datalistall: [],
    datalistallLoadingStatus: true,
    teamHeight: '',
    showSnackbar: false,
    loadingDataEngagement: true,
    databarchartEngagementScore: {},
    dataEngagementScoreHistoryByCohort: [],
    dataMasterLabel: [],
  },
  mutations: {
    setOptionsCohort(state:any, result:any) {
      state.optionsCohort = result
    },
    setCohortSelected(state: any, value: any) {
      state.cohortSelected = value
    },
    setInsightCohorts(state: any, result: any) {
      state.insight_cohorts = result
    },
    setChartHappyRisk(state: any, result: any) {
      state.datachart = result
    },
    setSelectMonth(state: any, value: any) {
      state.selectmonth = value
    },
    setQuestionCategory(state: any, value: any) {
      state.question_category = value
    },
    setInsightCohortsByComp(state: any, value: any) {
      state.insightcohortsByComp = value
    },
    setDataTable(state: any, value: any) {
      state.datalist = value
    },
    setDataTableAll(state: any, value: any) {
      state.datalistall = value
    },
    setDatalistallLoadingStatus(state: any, value: boolean) {
      state.datalistallLoadingStatus = value
    },
    setTeamHeight(state: any, value: any) {
      state.teamHeight = value
    },
    setSnackbar(state: any, value: any) {
      state.showSnackbar = value
    },
    setLoadingDataEngagement(state: any, value: any) {
      state.loadingDataEngagement = value
    },
    setChartEngagementScore(state: any, result: any) {
      state.databarchartEngagementScore = result
    },
  },
  actions: {
    getOptionsCohort({commit,dispatch,state}:any, user:any){
      const cohorts:Array<any> = [];
      firebase.database().ref(`cohorts/${user.company}`).once('value', (snapshot) => {
        snapshot.forEach((doc) => {
          const cohort = doc.val()
          cohort.key = doc.key
          cohort.value = doc.val().name
          cohorts.push(cohort)
        });
        commit('setOptionsCohort', _.sortBy(cohorts, [function(o:any) { return o.name; }]))
      });
    },
    async getInsightCohorts({ commit, dispatch, rootState, state }: any, {selectCohort, activeWhere}) {
      const insight_cohorts: Array<any> = [];
      let selectTeam:any
      console.log(selectCohort);
      if(selectCohort){
        commit('setCohortSelected', selectCohort)
        firebase.firestore().collection('insight_teams').where("company", "==", rootState.authen.user.company).where("quest_id", "==", '-Kgs61AHOnpJ3rfyQr6t').where("cohort", "==", selectCohort).where("date", ">=", format(addMonths(new Date(), -24), 'YYYY-MM-DD')).where("date", "<=", format(new Date(), 'YYYY-MM-DD')).orderBy('date', 'asc').get()
          .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const insight_cohort = doc.data()
            insight_cohort.key = doc.id
            insight_cohorts.push(insight_cohort)
          });
          commit('setInsightCohorts', insight_cohorts)
          if (state.selectmonth){
            if(activeWhere && activeWhere.type){
              dispatch('getDataChart', {value:state.selectmonth,activeWhere:activeWhere})
            }else{
              const activeWhere2 = {
                type: 'days',
                start: format(addDays(new Date(), -60), 'YYYY-MM-DD')
              };
              dispatch('getDataChart', {value:state.selectmonth,activeWhere:activeWhere2})
            }
          }
        });
      }else{
        if(!state.teamHeight){
          if(rootState.team.teamsall.length >0){
            let topmostArr: Array<any> = [];
            _.forEach(rootState.team.teamsall, (value)=> {
              if(value.parent == ''){
                topmostArr.push(value.key)
              }
            });
            selectTeam = topmostArr[0]
            if(topmostArr.length > 1){
              selectTeam = _.find(topmostArr, (value) => {
                const chk_topmost = _.find(rootState.team.teamsall, { parent: value });
                return !!chk_topmost;
              });
            }
            commit('setTeamHeight', selectTeam)
          }else{
            let topmostArr: Array<any> = [];
            let teamAll: Array<any> = [];
            await firebase.database().ref('team').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value', snapshot => {
              snapshot.forEach((doc): any => {
                teamAll.push(doc.val())
                if (!doc.val().parent){
                  topmostArr.push(doc.key)
                }
              });
              selectTeam = topmostArr[0]
              if(topmostArr.length > 1){
                selectTeam = _.find(topmostArr, (value) => {
                  const chk_topmost = _.find(teamAll, { parent: value });
                  return !!chk_topmost;
                });
              }
              commit('setTeamHeight', selectTeam)
            });
          }
        }else{
          selectTeam = state.teamHeight
        }

        const insight_teams: Array<any> = [];
        firebase.firestore().collection('insight_teams').where("quest_id", "==", '-Kgs61AHOnpJ3rfyQr6t').where("team", "==", selectTeam).where("date", ">=", format(addMonths(new Date(), -24), 'YYYY-MM-DD')).where("date", "<=", format(new Date(), 'YYYY-MM-DD')).orderBy('date', 'asc').get()
          .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const insight_team = doc.data()
            insight_team.key = doc.id
            insight_teams.push(insight_team)
          });
          commit('setInsightCohorts', insight_teams)
          if (state.selectmonth){
            if(activeWhere && activeWhere.type){
              dispatch('getDataChart', {value:state.selectmonth,activeWhere:activeWhere})
            }else{
              const activeWhere2 = {
                type: 'days',
                start: format(addDays(new Date(), -60), 'YYYY-MM-DD')
              };
              dispatch('getDataChart', {value:state.selectmonth,activeWhere:activeWhere2})
            }
          }
        });
      }
    },
    async getDataChart({ commit, state, rootState }: any, {value,activeWhere}) {
      const insight_cohorts = state.insight_cohorts
      let cohort:any = ''
      let team:any = ''
      console.log("calling getDataChart, cohort selected is: ", state.cohortSelected);
      console.log("month selected is: ", value);
      if (value.length > 0 && insight_cohorts.length > 0) {
        const active: Array<any> = [];
        if(state.cohortSelected === 'all'){
          team = state.teamHeight
          await firebase.firestore().collection('active_users_teams').where("date", ">=",activeWhere.start).where('team','==',team).where('company','==',rootState.authen.user.company).get().then((querySnapshot)=> {
            querySnapshot.forEach((doc)=> {
                active[doc.data().date] = doc.data();
            });
          });
        }else{
          cohort = state.cohortSelected
          // const cohort = (state.cohort === 'all')?state.cohortSelected:state.cohort
          await firebase.firestore().collection('active_users_teams').where("date", ">=",activeWhere.start).where('cohort','==',cohort).where('company','==',rootState.authen.user.company).get().then((querySnapshot)=> {
            querySnapshot.forEach((doc)=> {
                active[doc.data().date] = doc.data();
            });
          });
        }
        const response: Array<any> = [];
        const happy: Array<any> = [];
        const risk: Array<any> = [];
        const activeuser: Array<any> = [];
        const alluser: Array<any> = [];
        const activemonth: Array<any> = [];
        if(activeWhere.type && activeWhere.type === 'months' && state.cohortSelected === 'all'){
          await firebase.firestore().collection('active_users').where("date", ">=",activeWhere.start).where('company','==',rootState.authen.user.company).get().then((querySnapshot)=> {
            
            querySnapshot.forEach((doc)=> {
              activemonth[doc.data().year+'-'+doc.data().month+'-01'] = doc.data();
            });
          });
        }
        for (let m = 0; m < value.length; m++) {
          const _tmp: { [key: string]: number } = {}
          _tmp['sumhappy'] = 0
          _tmp['sumrisk'] = 0
          _tmp['rows'] = 0
          _tmp['totalusers'] = 0;
          _tmp['totalactive'] = 0;
          for (let index = 0; index < insight_cohorts.length; index++) {
            const element = insight_cohorts[index];
            if(activeWhere.type && activeWhere.type === 'weeks') {
              if (element.date >= value[m]['startdate'] && element.date < value[m]['enddate']) {
                _tmp['sumhappy'] += element.happy_percent
                _tmp['sumrisk'] += element.risk_percent
                _tmp['rows'] += 1
              }
            }else{
              if (element.date >= value[m]['startdate'] && element.date <= value[m]['enddate']) {
                _tmp['sumhappy'] += element.happy_percent
                _tmp['sumrisk'] += element.risk_percent
                _tmp['rows'] += 1
              }
            }
          }
          if(activeWhere.type && activeWhere.type === 'months' && state.cohortSelected === 'all') {
            for(const x in activemonth){
              if (x >= value[m]['startdate'] && x <= value[m]['enddate']) {
                _tmp['totalactive'] = (_tmp['totalactive'] < activemonth[x].active_users) ? activemonth[x].active_users: _tmp['totalactive'];
              }
            }
            for(const x in active){
              if (x >= value[m]['startdate'] && x <= value[m]['enddate']) {
                _tmp['totalusers'] = (_tmp['totalusers'] < active[x].usersTotal) ? active[x].usersTotal: _tmp['totalusers'];
              }
            }
            if(_tmp['totalactive']>_tmp['totalusers']){
              _tmp['totalusers'] = _tmp['totalactive'];
            }
            activeuser.push((_tmp['totalactive'] > 0) ? Math.ceil(Number(_tmp['totalactive']*100) / _tmp['totalusers']) : 0)
            alluser.push(_tmp['totalactive'])
          }else if(activeWhere.type && (activeWhere.type === 'weeks' || activeWhere.type === 'months' )) {
            let users = [];
            for(const x in active){
              if (x >= value[m]['startdate'] && x <= value[m]['enddate']) {
                _tmp['totalusers'] = (_tmp['totalusers'] < active[x].usersTotal) ? active[x].usersTotal: _tmp['totalusers'];
                users = _.union(users,active[x].users);
              }
            }
            activeuser.push((users.length > 0) ? Math.ceil(Number(users.length*100) / _tmp['totalusers']) : 0)
            alluser.push(users.length)
          }else{
            if(active[value[m]['startdate']]){
              if(active[value[m]['startdate']].usersActive>0){
                activeuser.push(Math.ceil((active[value[m]['startdate']].usersActive*100)/active[value[m]['startdate']].usersTotal))
              }else{
                activeuser.push(0);
              }
              alluser.push(active[value[m]['startdate']].usersActive);
            }else{
              activeuser.push(0);
              alluser.push(0);
            }
          }
          
          happy.push((_tmp['rows'] > 0) ? Math.ceil(_tmp['sumhappy'] / _tmp['rows']) : 0)
          risk.push((_tmp['rows'] > 0) ? Math.ceil(_tmp['sumrisk'] / _tmp['rows']) : 0)
          response['happy'] = happy
          response['risk'] = risk
          response['activeuser']= activeuser
          response['alluser']= alluser
        }
        commit('setChartHappyRisk', response)
      }
    },
    async getInsightCohortsByComp({ commit, dispatch, rootState, state }: any) {
      let questions: { [key: string]: string } = {};
      if(state.question_category.length == 0){
        if(rootState.question.questionsall.length>0){
          _.forEach(rootState.question.questionsall, (value,key)=> {
            questions[value.key] = value.category
          });
        }else{
          await firebase.database().ref('questions').orderByChild('status').equalTo('Y').once('value', snapshot => {
            snapshot.forEach((doc): any => {
              const question = doc.val()
              question.key = doc.key
              questions[question.key] = question.category
            });
          });
        }
        commit('setQuestionCategory', questions)
      }else{
        questions = state.question_category
      }

      const insight_cohorts: Array<any> = [];
      firebase.firestore().collection('insight_teams_fix').where("company", "==", rootState.authen.user.company).get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          const insight_cohort = doc.data()
          if(insight_cohort.cohort){
            insight_cohort.key = doc.id
            insight_cohort.category = questions[insight_cohort.quest_id]
            insight_cohorts.push(insight_cohort)
          }
        });
        commit('setInsightCohortsByComp', _.sortBy(insight_cohorts, [function (o: any) { return o.team; }]))
        // if (state.cohort) {
          dispatch('getDataTable', state.cohortSelected)
        // }
        setTimeout(() => {
          commit('setDatalistallLoadingStatus', false)
        }, 300)
      });
    },
    async getDataTable({ commit, dispatch, state, rootState }: any) {
      
      const insightcohortsByComp = state.insightcohortsByComp
      const optColor = { 'yellow': '#FBC02D', 'green': '#66BB6A', 'red': '#F44336'}
      const cohorts = state.optionsCohort
      const allUser =rootState.main.allUser
      // console.log("cohorts",cohorts)
      const extitUser:any={}
      const engagementTeam: Array<any> = [];

      await firebase.database().ref().child('users_employee_exit').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value', snapshot => {
        snapshot.forEach((doc):any => {
          const data = doc.val()
          data.key = doc.key
          let exit_date = ''
          if(data.exitdated){
            exit_date = data.exitdated
          }else if(data.archive_date){
            exit_date = data.archive_date
          }
          if(exit_date){
            const archive_date =format(new Date(exit_date), 'YYYY-MM-DD')
         
            if(archive_date>=format(addMonths(new Date(), -6), 'YYYY-MM-DD')&&format(new Date(data.workdate),'YYYY-MM-DD')<=format(addMonths(new Date(), -6), 'YYYY-MM-DD')){
              if(!extitUser[data.key]){
                extitUser[data.key]=data
              }
  
            }
          }
        });
        firebase.firestore().collection('engagement_index_30day_rolling_team').where("company", "==", rootState.authen.user.company).where("date", "==", format(addDays(new Date(), -1), 'YYYY-MM-DD')).get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const _data = doc.data()
              engagementTeam[_data.cohort] = _data
            });
            if (cohorts.length > 0 && insightcohortsByComp.length > 0) {
              const response: Array<any> = [];
              const data: { [key: string]: {} } = {};
      
              for (let i = 0; i < cohorts.length; i++) {
                const _tmp: { [key: string]: number } = {}
      
                _tmp['happy_percent'] = 0
                _tmp['risk_percent'] = 0
                const _tmp2: { [key: string]: string } = {}
                _tmp2['happiness'] = '#C7C7C7'
                _tmp2['satisfaction'] = '#C7C7C7'
                _tmp2['feedback'] = '#C7C7C7'
                _tmp2['wellness'] = '#C7C7C7'
                _tmp2['manager'] = '#C7C7C7'
                _tmp2['colleagues'] = '#C7C7C7'
                _tmp2['ambassadorship'] = '#C7C7C7'
                _tmp2['personal'] = '#C7C7C7'
                _tmp2['recognition'] = '#C7C7C7'
                _tmp2['alignment'] = '#C7C7C7'
                for (let index = 0; index < insightcohortsByComp.length; index++) {
                  const element = insightcohortsByComp[index];
                  if (element.cohort === cohorts[i].key){
                    if (element.quest_id === '-Kgs61AHOnpJ3rfyQr6t') {
                      _tmp['happirate'] = element.happy_percent
                      _tmp['riskrate'] = element.risk_percent
                    } else {
                      if (element.category === '-KxRzHeGK7cuwKtAKQwF'){
                        _tmp2['satisfaction'] = optColor[element.color]
                      } else if (element.category === '-KxS-JNn6sNeqTD0KE53'){
                        _tmp2['feedback'] = optColor[element.color]
                      } else if (element.category === '-KxS05m9KaS70Ai6ps93') {
                        _tmp2['wellness'] = optColor[element.color]
                      } else if (element.category === '-KxS-e4O2--BrGiRWbEF') {
                        _tmp2['manager'] = optColor[element.color]
                      } else if (element.category === '-KxRyiIXeDebHreB12mM') {
                        _tmp2['colleagues'] = optColor[element.color]
                      } else if (element.category === '-KxRzbMWTgeqpsSbCo_6') {
                        _tmp2['ambassadorship'] = optColor[element.color]
                      } else if (element.category === '-KxRdFigA6geGzv2zJHQ') {
                        _tmp2['personal'] = optColor[element.color]
                      } else if (element.category === '-KxRwgLlN0DpB0p7al7N') {
                        _tmp2['recognition'] = optColor[element.color]
                      } else if (element.category === '-KxS15s4DhoKSrjs4D7k') {
                        _tmp2['alignment'] = optColor[element.color]
                      }
                    }
                    _tmp2['total'] = element.total
                  }
                }
      
                _tmp['impact_rating']=0
                _tmp['count_member']=0
                _tmp['num_employees_beginning']=0
                _tmp['extitUser']=0
                _tmp2['avgImpact']=''
                _tmp2['retention_rate']=''
                const _tmp3: { [key: string]: any } = {}
                for(const key in cohorts[i].users){
                 
                
                  if(extitUser[key]){
      
                    if(extitUser[key].archive_type=='terminated'){
                      if(!_tmp3['terminated']){
                        _tmp3['terminated']={}
                        if(!_tmp3['terminated'][format(new Date(extitUser[key].exitdated), 'YYYY-MM')]){
                          _tmp3['terminated'][format(new Date(extitUser[key].exitdated), 'YYYY-MM')]=0
                        }
                      }else{
                        if(!_tmp3['terminated'][format(new Date(extitUser[key].exitdated), 'YYYY-MM')]){
                          _tmp3['terminated'][format(new Date(extitUser[key].exitdated), 'YYYY-MM')]=0
                        }
                      }
                      
                      _tmp3['terminated'][format(new Date(extitUser[key].exitdated), 'YYYY-MM')]++
                    }else if(data.archive_type=='other'){
                      if(!_tmp3['other']){  
                        _tmp3['other']={}
                        if(!_tmp3['other'][format(new Date(extitUser[key].exitdated), 'YYYY-MM')]){
                          _tmp3['other'][format(new Date(extitUser[key].exitdated), 'YYYY-MM')]=0
                        }
                     }else{
                      if(!_tmp3['other'][format(new Date(extitUser[key].exitdated), 'YYYY-MM')]){
                        _tmp3['other'][format(new Date(extitUser[key].exitdated), 'YYYY-MM')]=0
                      }
                     }
                      _tmp3['other'][format(new Date(extitUser[key].exitdated), 'YYYY-MM')]++
                    }else{
                      if(!_tmp3['resigned']){
                          _tmp3['resigned']={}
                          if(!_tmp3['resigned'][format(new Date(extitUser[key].exitdated), 'YYYY-MM')]){
                            _tmp3['resigned'][format(new Date(extitUser[key].exitdated), 'YYYY-MM')]=0
                          }
                      }else{
                        if(!_tmp3['resigned'][format(new Date(extitUser[key].exitdated), 'YYYY-MM')]){
                          _tmp3['resigned'][format(new Date(extitUser[key].exitdated), 'YYYY-MM')]=0
                        }
      
                      }
                      _tmp3['resigned'][format(new Date(extitUser[key].exitdated), 'YYYY-MM')]++
                    }
                    _tmp['extitUser']++
      
      
                  }else{
                    if(allUser[key]){
                      _tmp['impact_rating']+=allUser[key].impact_rating?parseFloat(allUser[key].impact_rating):0
                      _tmp['count_member']+=1
                      if(format(new Date(allUser[key].workdate),'YYYY-MM-DD')<=format(addMonths(new Date(), -6), 'YYYY-MM-DD')){
                        _tmp['num_employees_beginning']++
                    }
      
                    }
                  }
                }
                _tmp['num_employees_beginning']=_tmp['num_employees_beginning']+_tmp['extitUser']
                _tmp2['avgImpact'] =isNaN( _tmp['impact_rating']/_tmp['count_member'])?"0":( _tmp['impact_rating']/_tmp['count_member']).toFixed(1)
                _tmp2['retention_rate']=isNaN(((_tmp['num_employees_beginning']-_tmp['extitUser'])/_tmp['num_employees_beginning'])*100)?'0':( ((_tmp['num_employees_beginning']-_tmp['extitUser'])/_tmp['num_employees_beginning'])*100).toFixed(1)
                if(parseFloat(_tmp2['avgImpact']) >=70){
                  _tmp2['avgimpact_color']="green"
                }else if(parseFloat(_tmp2['avgImpact'])>=40){
                  _tmp2['avgimpact_color']="yellow"
                }else {
                  _tmp2['avgimpact_color']="red"
                }
                _tmp2['retention_rate_color']=''
                if(parseFloat(_tmp2['retention_rate'])>=90){
                  _tmp2['retention_rate_color']="green"
                }else if(parseFloat(_tmp2['retention_rate'])>=80){
                  _tmp2['retention_rate_color']="yellow"
                }else {
                  _tmp2['retention_rate_color']="red"
                }

                data[cohorts[i].key] = {
                  id: cohorts[i].key,
                  team: cohorts[i].name,
                  happirate: (Math.ceil(_tmp['happirate']))? Math.ceil(_tmp['happirate']) : 0,
                  riskrate: (Math.ceil(_tmp['riskrate'])) ? Math.ceil(_tmp['riskrate']) : 0,
                  satisfaction: _tmp2['satisfaction'],
                  feedback: _tmp2['feedback'],
                  wellness: _tmp2['wellness'],
                  manager: _tmp2['manager'],
                  colleagues: _tmp2['colleagues'],
                  ambassadorship: _tmp2['ambassadorship'],
                  personal: _tmp2['personal'],
                  recognition: _tmp2['recognition'],
                  alignment: _tmp2['alignment'],
                  total: _tmp2['total'],
                  avgimpact:_tmp2['avgImpact'] ? _tmp2['avgImpact'] : '-',
                  avgimpact_color:_tmp2['avgimpact_color'],
                  retention_rate:_tmp2['retention_rate']?_tmp2['retention_rate']:'-',
                  retention_color: _tmp2['retention_rate_color']?_tmp2['retention_rate_color']:'red',
                  terminate:_tmp3['terminated']?_tmp3['terminated']:[],
                  resigned:_tmp3['resigned']?_tmp3['resigned']:[],
                  other:_tmp3['other']?_tmp3['other']:[],
                  engagement_score:engagementTeam[cohorts[i].key]?engagementTeam[cohorts[i].key].cohort_DEBI:'-',
                }
                response.push(data[cohorts[i].key])
              }
              commit('setDataTableAll', _.sortBy(response, [function (o: any) { return o.happirate; }]))
              dispatch('getDataTablebyCohort', { cohort: '', type: 'parent' })
            }
          });
      })
    },
    async getDataTablebyCohort({ commit, state, dispatch, rootState }: any, data: any) {
      let response: Array<any> = [];
      if(!data.cohort){
        response = state.datalistall
      }else{
        response = _.filter(state.datalistall, { 'id': data.cohort })
      }
      _.forEach(response, (item, key) => {
        response[key]['children'] = []
      });
      if (data.type == 'parent') {
        commit('setDataTable', response)
      }
    },
    async getDataGraphExport({ commit, dispatch, rootState, state }: any, {table,activeWhere,filter, labeldate}) {
      console.time("Start")
      commit('setSnackbar', true)
      let cohort:any = ''
      let team:any = ''
      let selectMonth = state.selectmonth
      let startdate = ""
      let enddate = ""
      if(state.selectmonth.length > 0){
        startdate = state.selectmonth[0].startdate
        enddate = state.selectmonth[state.selectmonth.length - 1].enddate
      }
      if(state.cohortSelected === 'all'){
        team = state.teamHeight
      }else{
        cohort = state.cohortSelected
      }
      const allCohort = (await firebase.database().ref(`cohorts/${rootState.authen.user.company}`).once('value')).val()
      var promise2 = new Promise(function(resolve, reject) {
        const data2: Array<any> = [];
        if(state.cohortSelected === 'all'){
          firebase.firestore().collection('insight_teams').where("quest_id", "==", '-Kgs61AHOnpJ3rfyQr6t').where("company", "==", `${rootState.authen.user.company}`).where("date", ">=", startdate).where("date", "<=", enddate).orderBy('date', 'asc').get()
          .then(function (querySnapshot) {
              querySnapshot.forEach(function (doc) {
                if(doc.data().cohort){
                  if (data2[doc.data().cohort] === undefined) {
                    data2[doc.data().cohort] = new Array();
                  }
                  data2[doc.data().cohort].push(doc.data())
                }
              });
              resolve(data2);
          });
        }else{
          firebase.firestore().collection('insight_teams').where("quest_id", "==", '-Kgs61AHOnpJ3rfyQr6t').where("company", "==", `${rootState.authen.user.company}`).where("cohort", "==", cohort).where("date", ">=", startdate).where("date", "<=", enddate).orderBy('date', 'asc').get()
          .then(function (querySnapshot) {
              querySnapshot.forEach(function (doc) {
                if (data2[doc.data().cohort] === undefined) {
                  data2[doc.data().cohort] = new Array();
                }
                data2[doc.data().cohort].push(doc.data())
              });
              resolve(data2);
          });
        }
      });
      var promise1 = new Promise(function(resolve, reject) {
        const data1: Array<any> = [];
        if(state.cohortSelected === 'all'){
          firebase.firestore().collection('active_users_teams').where("date", ">=",activeWhere.start).where('company','==',rootState.authen.user.company).get()
          .then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              if(doc.data().cohort){
                if (data1[doc.data().cohort] === undefined) {
                  data1[doc.data().cohort] = new Array();
                }
                data1[doc.data().cohort][doc.data().date] = doc.data();
              }
            });
            resolve(data1);
          });
        }else{
          firebase.firestore().collection('active_users_teams').where("date", ">=",activeWhere.start).where('cohort','==',cohort).where('company','==',rootState.authen.user.company).get()
          .then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              if (data1[doc.data().cohort] === undefined) {
                data1[doc.data().cohort] = new Array();
              }
              data1[doc.data().cohort][doc.data().date] = doc.data();
            });
            resolve(data1);
          });
        }
      });
      Promise.all([promise1, promise2]).then((values)=> {
        const active:any = values[0]
        const insight_teams:any = values[1]
        let cohortSelected:any
        if(cohort){
          cohortSelected = new Object()
          cohortSelected[cohort] = allCohort[cohort]
        }else{
          cohortSelected = allCohort
        }
        const response: Array<any> = [];
        const teamforsort: Array<any> = [];
        Object.entries(cohortSelected).forEach(([key, value]) =>{
          const happy: Array<any> = [];
          const risk: Array<any> = [];
          const activeuser: Array<any> = [];
          const alluser: Array<any> = [];
          for (let m = 0; m < selectMonth.length; m++) {
            let _tmp:Array<any> = [];
            if (_tmp[key] === undefined) {
              _tmp[key] = new Array();
            }
            _tmp[key]['sumhappy'] = 0
            _tmp[key]['sumrisk'] = 0
            _tmp[key]['rows'] = 0
            _tmp[key]['totalusers'] = 0;
            _tmp[key]['totalactive'] = 0;
            if(insight_teams[key]){
              for (let index = 0; index < insight_teams[key].length; index++) {
                const element = insight_teams[key][index];
                if(activeWhere.type && activeWhere.type === 'weeks') {
                  if (element.date >= selectMonth[m]['startdate'] && element.date < selectMonth[m]['enddate']) {
                    _tmp[key]['sumhappy'] += element.happy_percent
                    _tmp[key]['sumrisk'] += element.risk_percent
                    _tmp[key]['rows'] += 1
                  }
                }else{
                  if (element.date >= selectMonth[m]['startdate'] && element.date <= selectMonth[m]['enddate']) {
                    _tmp[key]['sumhappy'] += element.happy_percent
                    _tmp[key]['sumrisk'] += element.risk_percent
                    _tmp[key]['rows'] += 1
                  }
                }
              }
            }
            if(activeWhere.type && (activeWhere.type === 'weeks' || activeWhere.type === 'months' )) {
              let users = [];
              for(const x in active[key]){
                if (x >= selectMonth[m]['startdate'] && x <= selectMonth[m]['enddate']) {
                  _tmp[key]['totalusers'] = (_tmp[key]['totalusers'] < active[key][x].usersTotal) ? active[key][x].usersTotal: _tmp[key]['totalusers'];
                  users = _.union(users,active[key][x].users);
                }
              }
              activeuser.push((users.length > 0) ? Math.ceil(Number(users.length*100) / _tmp[key]['totalusers']) +'%' : 0 +'%')
              if(selectMonth[m]['startdate'] >= '2020-09-01'){
                alluser.push(users.length)
              }else{
                alluser.push('-')
              }
            }else{
              if(active[key] && active[key][selectMonth[m]['startdate']]){
                if(active[key][selectMonth[m]['startdate']].usersActive>0){
                  activeuser.push(Math.ceil((active[key][selectMonth[m]['startdate']].usersActive*100)/active[key][selectMonth[m]['startdate']].usersTotal)+'%')
                }else{
                  activeuser.push(0+'%');
                }
                if(selectMonth[m]['startdate'] >= '2020-09-01'){
                  alluser.push(active[key][selectMonth[m]['startdate']].usersActive);
                }else{
                  alluser.push('-')
                }
              }else{
                activeuser.push(0+'%');
                if(selectMonth[m]['startdate'] >= '2020-09-01'){
                  alluser.push(0);
                }else{
                  alluser.push('-')
                }
              }
            }
            happy.push((_tmp[key]['rows'] > 0) ? Math.ceil(_tmp[key]['sumhappy'] / _tmp[key]['rows']) +'%' : 0+'%')
            risk.push((_tmp[key]['rows'] > 0) ? Math.ceil(_tmp[key]['sumrisk'] / _tmp[key]['rows']) +'%' : 0+'%')
          }
          if (response[key] === undefined) {
            response[key] = new Array();
          }
          if(key == cohort){
            response[key]['order'] = 0
          }else{
            response[key]['order'] = 1
          }
          response[key]['team_name'] = (allCohort[key]) ? allCohort[key].name : ''
          response[key]['happy'] = happy
          response[key]['risk'] = risk
          response[key]['activeuser']= activeuser
          response[key]['alluser']= alluser
          teamforsort.push({order:response[key]['order'],team_key:key , team_name: response[key]['team_name'] })

        });
        dispatch('genDataExport', {labeldate, filter,dataexportall: response , teamorder: _.orderBy(teamforsort, ["order","team_name"], ["asc","asc"])})
        console.timeEnd("Start")
      });
    },
    async genDataExport({ commit, state, dispatch, rootState }: any, obj:any) {
      const labeldate = obj.labeldate
      const filter = obj.filter
      const dataexportall = obj.dataexportall
      const teamMaster = obj.teamorder
      const Excel = require('exceljs');
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet('mySheet');

      /*TITLE*/
      ws.getRow(2).height = 20
      ws.getCell('B2').font = { name: 'Arial', size: 14, bold: true }
      ws.getCell('B2').alignment = { vertical: 'middle' }
      ws.getCell('B2').value = 'Team Insight for ' + rootState.authen.user.company_name

      ws.getRow(3).height = 20
      ws.getCell('B3').font = { name: 'Arial', size: 11 }
      ws.getCell('B3').alignment = { vertical: 'middle' }
      ws.getCell('B3').value = filter

      // /*Column headers*/
      ws.getColumn('A').width = 5;
      ws.getColumn('B').width = 25;
      ws.getColumn('C').width = 25;
      let header:any = ['','Team Name','']
      ws.getRow(5).values = _.concat(header,labeldate)
      
      /*Data*/
      _.forEach(teamMaster, (value, key)=> {
        let row1:any = ['']
        row1.push(value.team_name)
        row1.push('Happiness Rate')
        ws.addRow(_.concat(row1,dataexportall[value.team_key].happy))

        let row2:any = ['','']
        row2.push('Risk Rate')
        ws.addRow(_.concat(row2,dataexportall[value.team_key].risk))

        let row3:any = ['','']
        row3.push('Activity Rate')
        ws.addRow(_.concat(row3,dataexportall[value.team_key].activeuser))

        let row4:any = ['','']
        row4.push('Active Users')
        ws.addRow(_.concat(row4,dataexportall[value.team_key].alluser))
      });

      ws.eachRow(function (row) {
        if(row.number == 5){
          row.eachCell(function (cell) {
            if(cell.col == 2){
                ws.getCell(cell.address).font = { name: 'Arial', size: 11, bold: true }
            }else if(cell.col > 3){
              ws.getCell(cell.address).font = { name: 'Arial', size: 11, bold: true }
              ws.getCell(cell.address).alignment = { horizontal: 'right' };
              ws.getColumn(cell.address.replace(/[0-9]/g, '')).width = 15;
            }
          });
        }else if(row.number > 5 ){
          row.eachCell(function (cell) {
            if(cell.col == 2){
              ws.getCell(cell.address).font = { name: 'Arial', size: 11 }
            }else if(cell.col == 3){
              ws.getCell(cell.address).font = { name: 'Arial', size: 10 }
            }else if(cell.col > 3){
              ws.getCell(cell.address).font = { name: 'Arial', size: 10 }
              ws.getCell(cell.address).alignment = { horizontal: 'right' };
            }
          });
        }
      });
      
      wb.xlsx.writeBuffer( {
        base64: true
      })
      .then( function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = 'Team Insight' + ".xlsx";
          document.body.appendChild(a);
          a.click();
          setTimeout(function() {
              commit('setSnackbar', false)
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);
              },
              0);
      })
      .catch(function(error) {
          console.log(error.message);
      });
    },
    async sortDataTable({ commit, state, dispatch, rootState }: any, index:any) {
      let response:Array<any> = [];
      if (index == "1") {
        response = _.orderBy(
          state.datalist,
          [
            function (o) {
              return o.happirate;
            },
          ],
          ["desc"]
        );
      } else if (index == "2") {
        response = _.orderBy(
          state.datalist,
          [
            function (o) {
              return o.riskrate;
            },
          ],
          ["asc"]
        );
      } else if (index == "3") {
        response = _.orderBy(
          state.datalist,
          [
            function (o) {
              return o.riskrate;
            },
          ],
          ["desc"]
        );
      } else {
        response = _.orderBy(
          state.datalist,
          [
            function (o) {
              return o.happirate;
            },
          ],
          ["asc"]
        );
      }
      commit('setDataTable', response)
    },
    async getCohortEngagementScore({ commit, dispatch, rootState, state }: any, {selectCohort}) {
      commit('setLoadingDataEngagement',true)
      let dataChart = {};
      dataChart['cohort'] = [];
      dataChart['manager'] = [];
      dataChart['leader'] = [];
      dataChart['cohort_members'] = [];
      dataChart['manager_members'] = [];
      dataChart['leader_members'] = [];
      dataChart['labels'] = [];
      dataChart['newLabels'] = [];
      let dateNow = new Date()
      let startMonth = format(addMonths(new Date(), -5), 'YYYY-MM')
      let endMonth = format(dateNow, 'YYYY-MM-DD')
      startMonth = startMonth + '-01'
      let labelCheck:any = [];
      if(state.dataEngagementScoreHistoryByCohort && state.dataEngagementScoreHistoryByCohort[selectCohort]){
        commit('setChartEngagementScore', state.dataEngagementScoreHistoryByCohort[selectCohort]);
        commit('setLoadingDataEngagement', false);
      }else{
        if(Object.keys(state.dataMasterLabel).length == 0){
          let date = startMonth
          do {
            state.dataMasterLabel[date] = true
            date = format(addDays(new Date(date), 1), 'YYYY-MM-DD')
          }
          while (date < endMonth);
        }
        let dataMasterLabel = state.dataMasterLabel
        let dataByDate:any = []
        await firebase.firestore().collection('engagement_index_30day_rolling_team').where("company","==",rootState.authen.user.company).where("cohort", "==", selectCohort).where("date", ">=", startMonth).where("date", "<", endMonth).get()
          .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            dataByDate[data.date] = data
          });
          for(const x in dataMasterLabel){
            const dateLabel = format(new Date(x), 'D MMMM YY')
            let Month = format(new Date(x), 'MMM')
            if(labelCheck[Month] == undefined){
              labelCheck[Month] = true
              dataChart['labels'].push(Month)
            }else{
              dataChart['labels'].push('')
            }
            if(dataByDate[x]){
              dataChart['cohort'].push((dataByDate[x].cohort_DEBI) ? Number(dataByDate[x].cohort_DEBI.toFixed(0)) : 0)
              dataChart['manager'].push((dataByDate[x].manager_DEBI) ? Number(dataByDate[x].manager_DEBI.toFixed(0)) : 0)
              dataChart['leader'].push((dataByDate[x].leader_DEBI) ? Number(dataByDate[x].leader_DEBI.toFixed(0)) : 0)
              dataChart['cohort_members'].push((dataByDate[x].cohort_members) ? dataByDate[x].cohort_members : 0)
              dataChart['manager_members'].push((dataByDate[x].manager_members) ? dataByDate[x].manager_members : 0)
              dataChart['leader_members'].push((dataByDate[x].leader_members) ? dataByDate[x].leader_members : 0)
            }else{
              dataChart['cohort'].push(0)
              dataChart['manager'].push(0)
              dataChart['leader'].push(0)
              dataChart['cohort_members'].push(0)
              dataChart['manager_members'].push(0)
              dataChart['leader_members'].push(0)
            }
            dataChart['newLabels'].push(dateLabel)
          }
          state.dataEngagementScoreHistoryByCohort[selectCohort] = dataChart
          commit('setChartEngagementScore', dataChart);
          commit('setLoadingDataEngagement', false);
        });
      }
    },
  },
  getters: {
    optionsCohort: (state:any) => {
      return state.optionsCohort
    },
    datachart: (state: any) => {
      return state.datachart
    },
    datalist: (state: any) => {
      return state.datalist
    },
    dataListLoading: (state:any) => {
      return state.datalistallLoadingStatus
    },
    showSnackbar: (state:any) => {
      return state.showSnackbar
    },
    loadingDataEngagement: (state:any) => {
      return state.loadingDataEngagement
    },
    databarchartEngagementScore: (state: any) => {
      return state.databarchartEngagementScore
    },
  }
}